import { Chip } from '@mui/material'

const Badge = {
  active: (label: string) => (
    <Chip
      label={label}
      size="small"
      sx={{ backgroundColor: 'success.main', color: 'white' }}
    />
  ),
  canceled: (label: string) => (
    <Chip
      label={label}
      size="small"
      sx={{ backgroundColor: 'error.light', color: 'white' }}
    />
  ),
  completed: (label: string) => (
    <Chip
      label={label}
      size="small"
      sx={{ backgroundColor: 'success.dark', color: 'white' }}
    />
  ),
  default: (label: string) => <Chip label={label} size="small" />,
  dispatched: (label: string) => (
    <Chip
      label={label}
      size="small"
      sx={{ backgroundColor: 'info.main', color: 'white' }}
    />
  ),
  failed: (label: string) => (
    <Chip
      label={label}
      size="small"
      sx={{ backgroundColor: 'error.main', color: 'white' }}
    />
  ),
  matching: (label: string) => (
    <Chip
      label={label}
      size="small"
      sx={{ backgroundColor: 'warning.light', color: 'white' }}
    />
  ),
  offer: (label: string) => (
    <Chip
      label={label}
      size="small"
      sx={{ backgroundColor: 'secondary.light', color: 'white' }}
    />
  ),
  'offer-rejected': (label: string) => (
    <Chip
      label={label}
      size="small"
      sx={{ backgroundColor: '#ab47bc', color: 'white' }}
    />
  ),
  pending: (label: string) => (
    <Chip
      label={label}
      size="small"
      sx={{ backgroundColor: 'warning.main', color: 'white' }}
    />
  ),
  rejected: (label: string) => (
    <Chip
      label={label}
      size="small"
      sx={{ backgroundColor: 'error.dark', color: 'white' }}
    />
  ),
} as const

type Props = {
  label: string
  status: string
}

export const StatusBadge = ({ label, status }: Props) => {
  const badgeStatus = status as keyof typeof Badge
  if (!status || !Badge[badgeStatus]) return null

  return Badge[badgeStatus](label)
}
